import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useParams, useNavigate, generatePath } from "react-router-dom";
import Footer from "../Footer";
import BottomBarIcons from "../BottomBarIcons";
import useGetClientId from "../../hooks/useGetClientId";
import http from "../../api/server";
import {
  GET_PROPERTIES_AND_INSPECTORS_BY_CLIENT,
  UPSERT_NEW_INSPECTION,
  GET_ALL_INSPECTION_MASTER,
} from "../../api/apiPath";

import Header from "../Header";
import Sidebar from "../Sidebar";
import { Button } from "react-bootstrap";
import Select from "react-select";
import Toaster from "../common/Toaster";
import SidebarIcons from "../SidebarIcons";
import AutocompleteInput from "../common/AutocompleteInput";

// import { sampleInspectorRows } from "../common/constant";
const FORMDATA = {
  propertyName: "",
  inspectionType: "",
  approvalDueDate: "",
};

const NewInspection = () => {
  const { userObj } = useSelector((state) => state.user);
  const { clientNameParam, inspectionMasterId } = useParams();

  const [formData, setFormData] = useState({
    ...FORMDATA,
    inspectionType: "Fire Door Survey",
  });
  const [scheduledInspectionDate, setScheduledInspectionDate] = useState(null);
  const [selectedInspectors, setSelectedInpsectors] = useState([]);
  const [errors, setErrors] = useState(FORMDATA);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [propertyOptions, setPropertyOptions] = useState([]);
  const [inspectorOptions, setInspectorOptions] = useState([]);
  const [cityInspectorOptions, setCityInspectorOptions] = useState([]);
  const [propertyInspectors, setPropertyInspectors] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(
    Object.values(formData).some(
      (value) => value === "" || value === null || value === undefined,
    ) || selectedInspectors.length === 0,
  );
  const [error, setError] = useState(null);
  const today = new Date().toISOString().split("T")[0];

  const navigate = useNavigate();

  const clientObj = useGetClientId();

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  useEffect(() => {
    if (clientObj.clientId && userObj) {
      handleGetAllPropertyByClinetID(clientObj.clientId);
      //setAllPropertyList(sampleInspectorRows);
    }
  }, [clientObj.clientId, clientObj.loading]);

  const handleGetAllPropertyByClinetID = async (clientId) => {
    try {
      const response = await http.get(
        GET_PROPERTIES_AND_INSPECTORS_BY_CLIENT +
          "?ClientId=" +
          clientId +
          "&loggedinUserEmail=" +
          userObj?.userEmail,
      );
      if (response.status === 200) {
        console.log("response.data", response?.data);
        const propertyList = response?.data?.properties;
        const sortedprops = [...propertyList].sort((a, b) =>
          String(a?.propertyName ?? "").localeCompare(
            String(b?.propertyName ?? ""),
            undefined,
            { sensitivity: "base" }, // case-insensitive
          ),
        );

        setPropertyOptions(sortedprops);
        const inspectorOptions = response?.data?.inspectors.map((i) => ({
          value: i.inspectorId,
          label: i.inspectorName,
          cityId: i.cityId,
        }));
        setInspectorOptions(inspectorOptions);
        setPropertyInspectors(response?.data?.propertyInspectors);

        if (inspectionMasterId) {
          await setEditInspectionData(inspectorOptions);
        }
      }
    } catch (error) {
      return error;
    } finally {
      // setLoading(false);
    }
  };

  const setEditInspectionData = async (inspectorOptions) => {
    try {
      const response = await http.get(
        GET_ALL_INSPECTION_MASTER + "?ClientId=" + clientObj?.clientId,
      );
      console.log(response);
      if (response?.status === 200) {
        const editData = response?.data?.filter(
          (x) => x.inspectionMasterId == inspectionMasterId,
        );
        if (editData.length > 0) {
          setFormData({
            ...formData,
            propertyName: editData[0].properties[0]?.propertyMasterId,
            inspectionType: editData[0].inspectionType,
            approvalDueDate: formatDateString(editData[0].approvalDueDate),
            status: editData[0].status,
          });
          setScheduledInspectionDate(editData[0].scheduledInspectionDate);

          const preinsp = editData[0].assignedInspectors.map((i) => ({
            value: i.inspectorId,
            label: i.inspectorName,
          }));
          setSelectedInpsectors(preinsp);
          const cityOptionsnew = getCityInspectorOptions(
            preinsp,
            editData[0].properties[0]?.cityId,
            inspectorOptions,
          );
          setCityInspectorOptions(cityOptionsnew);
        }
      }
    } catch (error) {
      console.log(error);
      setError(error);
    }
  };

  const formatDateString = (dateString) => {
    const dateObj = new Date(dateString);
    if (!isNaN(dateObj)) {
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const day = String(dateObj.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    return "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedFormData = formData;

    if (name === "propertyName") {
      let preinsp = [];
      const selectedInsp = propertyInspectors.filter(
        (x) =>
          x.propertyMasterId === value &&
          x.inspectorId !== 0 &&
          x.inspectorName !== "",
      );
      console.log("sele", selectedInsp);
      if (value !== "" && selectedInsp.length !== 0) {
        updatedFormData = {
          ...formData,
          [name]: value,
          //   preDefinedInspector: selectedInsp[0].inspectorId,
        };
        preinsp = selectedInsp.map((i) => ({
          value: i.inspectorId,
          label: i.inspectorName,
        }));
      } else {
        updatedFormData = {
          ...formData,
          [name]: value,
          //   preDefinedInspector: "",
        };
        preinsp = [];
      }
      setSelectedInpsectors(preinsp);
      setErrors({
        ...errors,
        preDefinedInspector: "",
      });
    } else {
      updatedFormData = { ...formData, [name]: value };
    }

    handleDisableSave(updatedFormData, selectedInspectors);
    setFormData(updatedFormData);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : prevErrors[name],
    }));
  };

  const handlePropertyChange = (site) => {
    let updatedFormData = formData;
    let preinsp = [];
    if (site != null) {
      const selectedInsp = propertyInspectors.filter(
        (x) =>
          x.propertyMasterId === site.propertyMasterId &&
          x.inspectorId !== 0 &&
          x.inspectorName !== "",
      );
      console.log("sele", selectedInsp, inspectorOptions);
      if (site.propertyMasterId !== "" && selectedInsp.length !== 0) {
        updatedFormData = {
          ...formData,
          propertyName: site.propertyMasterId,
          //   preDefinedInspector: selectedInsp[0].inspectorId,
        };

        preinsp = selectedInsp.map((i) => ({
          value: i.inspectorId,
          label: i.inspectorName,
          cityid: i.cityId,
        }));

        const cityOptionsnew = getCityInspectorOptions(preinsp, site.cityId);

        setCityInspectorOptions(cityOptionsnew);
      } else {
        updatedFormData = {
          ...formData,
          propertyName: site.propertyMasterId,
          //   preDefinedInspector: "",
        };
        preinsp = [];
        setCityInspectorOptions([]);
      }
    } else {
      updatedFormData = {
        ...formData,
        propertyName: "",
        //   preDefinedInspector: "",
      };
      preinsp = [];
      setCityInspectorOptions([]);
    }
    setSelectedInpsectors(preinsp);

    setErrors({
      ...errors,
      preDefinedInspector: "",
    });

    handleDisableSave(updatedFormData, selectedInspectors);
    setFormData(updatedFormData);
    setErrors((prevErrors) => ({
      ...prevErrors,
      propertyName: site ? "" : prevErrors.propertyName,
    }));
  };

  const getCityInspectorOptions = (preinsp, cityId, newinspectorOptions) => {
    const normalizeOption = (o) => ({
      value: o?.value ?? o?.inspectorId,
      label: o?.label ?? o?.inspectorName ?? "Unnamed",
      cityId: o?.cityId ?? o?.cityid, // accept both keys
    });
    const inspOpt = newinspectorOptions
      ? newinspectorOptions
      : inspectorOptions;
    const cityOptions = inspOpt
      .map(normalizeOption)
      .filter((ins) => Number(ins.cityId) === Number(cityId));

    const merged = [
      ...cityOptions.map(normalizeOption),
      ...preinsp.map(normalizeOption),
    ];

    const cityOptionsnew = Array.from(
      new Map(merged.map((o) => [String(o.value), o])).values(),
    );

    return cityOptionsnew;
  };

  const handleDisableSave = (data, inspector) => {
    setSubmitDisabled(
      Object.values(data).some(
        (value) => value === "" || value === null || value === undefined,
      ) || inspector.length === 0,
    );
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.propertyName || formData.propertyName === "0")
      newErrors.propertyName = "Property Name is required";
    if (!formData.inspectionType || formData.inspectionType === "0")
      newErrors.inspectionType = "Inspection Type is required";
    if (!formData.approvalDueDate)
      newErrors.approvalDueDate = "Approval Due Date is required";
    if (!selectedInspectors || selectedInspectors.length === 0)
      newErrors.preDefinedInspector = "Inspector is required";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      console.log("Form submitting...", formData);
      setIsSubmitting(true);
      const inspectorArray = selectedInspectors?.map((u) => u.value.toString());
      try {
        const payload = {
          inspectionMasterId: inspectionMasterId ? inspectionMasterId : 0,
          propertyMasterId: formData.propertyName,
          clientId: clientObj?.clientId,
          inspectionType: formData.inspectionType,
          approvalDueDate: formData.approvalDueDate,
          scheduledInspectionDate: inspectionMasterId
            ? scheduledInspectionDate
            : "2025-09-23T15:28:53.638Z",
          assignedInspectorsUserIds: inspectorArray,
          status: inspectionMasterId ? formData.status : "New",
          createDate: new Date().toISOString(),
          createdByUserId: userObj?.userId,
          modifiedOn: new Date().toISOString(),
          modifiedByUserId: userObj?.userId,
          isActive: true,
          loggedInUserEmail: userObj?.userEmail,
        };

        await submitFormData(JSON.stringify(payload));
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const submitFormData = async (payload) => {
    try {
      const response = await http.post(UPSERT_NEW_INSPECTION, payload);
      if (response?.data?.result?.isSuccess === true) {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Inspection has been saved successfully.",
          });
        }, 1000);
        handleCancel();
        console.log(response);
      } else {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in saving data, please try again.",
          });
        }, 1000);
      }
    } catch (error) {
      console.error("Error submitting form:", error.data.result.message);
      if (error.status === 400) {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: error?.data?.result?.message,
          });
        }, 1000);
      } else {
        setError(error);
      }
    }
  };

  const handleCancel = () => {
    navigate(
      generatePath("/client/:clientNameParam/inspectionDashboard", {
        clientNameParam,
      }),
    );
  };
  const handleReset = () => {
    setErrors(FORMDATA);
    setFormData({ ...FORMDATA, inspectionType: "Fire Door Survey" });
    setSelectedInpsectors([]);
    setSubmitDisabled(true);
  };

  if (error)
    return (
      <>
        <div className="inCenterDiv">
          <i className="bi bi-exclamation-triangle red"></i>
          <h3>Something went wrong!</h3>
          <p>{error?.message}</p>
          <div className="col-sm-12 mb-4 text-center">
            <Link
              to={generatePath("/client/:clientNameParam/", {
                clientNameParam,
              })}
            >
              Go back to Login
            </Link>
          </div>
        </div>
      </>
    );

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={closeButton}
      />
      {userObj && (
        <div className="dashboard_body_main">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}
          <div className="d-flex dashboard_body flex-column py-1 w-100">
            <div className="p-2 border-0 w-100">
              <div className="dashboard_header">
                <h2 className="mb-0">
                  {inspectionMasterId ? "Edit Inspection" : "New Inspection"}
                </h2>
                <p className="header-description">
                  {inspectionMasterId
                    ? "Edit inspection for a property"
                    : "Create new inspection for a property"}
                </p>
              </div>
              <div className="resident-card px-2 pt-3 pb-4 mb-4">
                <div className="card-body-section px-3">
                  <div className="form-group">
                    <label htmlFor="propertyName">
                      Site Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <AutocompleteInput
                      masterList={propertyOptions || []}
                      getOptionLabel={(c) => c?.propertyName || ""}
                      getOptionValue={(c) => c?.propertyMasterId || ""}
                      placeholder="Select Site"
                      inputClassName=""
                      wrapperClassName=""
                      notFoundText="Site not found"
                      className={
                        errors.propertyName
                          ? "input-error form-select"
                          : "form-select"
                      }
                      name="propertyName"
                      id="propertyName"
                      aria-label="Floating label select example"
                      value={formData.propertyName}
                      //   disabled={isView}
                      onValueChange={(value, site) => {
                        console.log("val", value, site);
                        handlePropertyChange(site);
                      }}
                    />
                    {errors.propertyName && (
                      <span className="formError">{errors.propertyName}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="inspectionType">
                      Inspection Type <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className={
                        errors.inspectionType
                          ? "input-error form-select"
                          : "form-select"
                      }
                      name="inspectionType"
                      id="inspectionType"
                      aria-label="Floating label select example"
                      value={formData.inspectionType}
                      disabled
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    >
                      {/* <option selected value="0">
                        Select Inspection Type
                      </option> */}

                      <option value="Fire Door Survey">Fire Door Survey</option>
                    </select>
                    {errors.inspectionType && (
                      <span className="formError">{errors.inspectionType}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="approvalDueDate">
                      Approval Due Date <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      className={errors.approvalDueDate ? "input-error" : ""}
                      placeholder="Select approval due date"
                      id="approvalDueDate"
                      type="Date"
                      min={today}
                      name="approvalDueDate"
                      value={formData.approvalDueDate}
                      onChange={handleChange}
                    />
                    {errors.approvalDueDate && (
                      <span className="formError mt-0">
                        {errors.approvalDueDate}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="floatingEmail">
                      Inspector(s) <span style={{ color: "red" }}>*</span>
                    </label>
                    {/* <Select
                      isMulti
                      options={cityInspectorOptions}
                      value={selectedInspectors}
                      className={
                        errors.preDefinedInspector ? "input-error" : ""
                      }
                      onChange={(e) => {
                        console.log("insp", selectedInspectors, e);
                        setSelectedInpsectors(e);
                        handleDisableSave(formData, e);
                        setErrors({
                          ...errors,
                          preDefinedInspector: "",
                        });
                      }}
                      name="preDefinedInspector"
                      isClearable
                      menuPortalTarget={document.body}
                      styles={{
                        container: (base) => ({
                          ...base,
                          width: "100%",
                          height: "2.81rem",
                        }),
                        control: (base) => ({
                          ...base,
                          minHeight: "2.81rem",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                    /> */}
                    <Select
                      isMulti
                      options={cityInspectorOptions}
                      value={selectedInspectors}
                      isDisabled={
                        inspectionMasterId !== null &&
                        inspectionMasterId !== undefined
                      }
                      className={
                        errors.preDefinedInspector ? "input-error" : ""
                      }
                      onChange={(e) => {
                        setSelectedInpsectors(e);
                        handleDisableSave(formData, e);
                        setErrors({
                          ...errors,
                          preDefinedInspector: "",
                        });
                      }}
                      name="preDefinedInspector"
                      isClearable
                      menuPortalTarget={document.body}
                      styles={{
                        container: (base) => ({
                          ...base,
                          width: "100%",
                          height: "2.81rem",
                        }),
                        control: (base) => ({
                          ...base,
                          minHeight: "2.81rem",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                    />

                    {errors.preDefinedInspector && (
                      <span className="formError mt-0">
                        {errors.preDefinedInspector}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="pb-3 button-group">
                <Button
                  type="reset"
                  className="col-12 col-sm-12 col-lg-2 col-md-3"
                  size="md"
                  variant={
                    inspectionMasterId !== null &&
                    inspectionMasterId !== undefined
                      ? "secondary"
                      : "tertiary"
                  }
                  onClick={handleCancel}
                  style={{ fontWeight: "600" }}
                >
                  Cancel
                </Button>

                {(inspectionMasterId === null ||
                  inspectionMasterId === undefined) && (
                  <Button
                    type="reset"
                    className="col-12 col-sm-12 col-lg-2 col-md-3"
                    size="md"
                    variant="secondary"
                    onClick={handleReset}
                    style={{ fontWeight: "600" }}
                  >
                    Reset
                  </Button>
                )}
                <Button
                  variant="primary"
                  size="md"
                  className="col-12 col-sm-12 col-lg-2 col-md-3"
                  active
                  type="submit"
                  onClick={handleSubmit}
                  style={{ fontWeight: "600" }}
                  disabled={isSubmitting || submitDisabled}
                >
                  {isSubmitting ? "Saving..." : "Save Inspection"}
                </Button>
              </div>
            </div>
          </div>
          <div className="bottom-bar-spacing"></div>
          <BottomBarIcons />
        </div>
      )}
      <Footer />
    </>
  );
};

export default NewInspection;
